<template>
  <div id="worldmap-nav" class="worldmap-nav">
    <attribute-nav :selectMultiple="false" :closeOnSelect="false" :toggleable="false" :closed="false"></attribute-nav>
    <CountriesRegime></CountriesRegime>
  </div><!-- /.compare-attributes-nav -->
</template>

<script>
import AttributeNav from './../AttributesNavigation/Nav'
import CountriesRegime from './../AttributesNavigation/CountriesRegime'

export default {
  name: 'worldmap-nav',
  components: {
    CountriesRegime,
    'attribute-nav': AttributeNav
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/navigation/PageSidebarNavigation/WorldMap.vue